import { Stack, Text, Title } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useMantineTheme } from '@mantine/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

import RootButton from '../Buttons/RootButton'
import Loading from '../Loading'

interface ErrorSyncingAirdropProps {
  errorMesssage: string
  retry: () => void
}

const ErrorSyncingAirdrop: React.FC<ErrorSyncingAirdropProps> = ({ errorMesssage, retry }) => {
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  return (
    <Stack style={{ gap: '20px' }}>
      <Title order={isMobile ? 3 : 2}>
        {t('components.airdrop.interactError', 'Sync with airdrop bot not successful')}
      </Title>
      <Text style={{ fontSize: 14, color: theme.colors.notification[0] }}>{errorMesssage}</Text>
      <Loading error size="110px" />
      <Stack style={{ flexDirection: 'row' }}>
        <RootButton secondary expand onClick={retry}>
          {t('buttons.retry', 'Retry')}
        </RootButton>
      </Stack>
    </Stack>
  )
}

export default ErrorSyncingAirdrop
